<template>
  <div class="member">
    <van-nav-bar
    v-if="source==1"
    title="用户信息"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-cell-group :style="{'margin-top':source==1?'45px':'0'}">
      <van-uploader :after-read="afterRead">
        <van-field
        clearable
        value="头像"
        :left-icon="params.avatar_url"
        input-align='right'
        right-icon="arrow"
        />
      </van-uploader>
      <van-field
      v-model="params.username"
      clearable
      label="昵称"
      placeholder="请输入用户名"
      @input="checkName"
      />
      <van-field
      v-model="params.sexName"
      label="性别"
      right-icon="arrow"
      placeholder="请选择性别"
      @click="showPickerd"

      />
      <van-field
      v-model="params.hometown"
      clearable
      label="家乡"
      right-icon="arrow"
      placeholder="请选择家乡"
      @click="showAread"
      />
      <van-field
      v-model="params.intro"
      clearable
      label="签名"
      placeholder="请输入签名"
      @input="checkIntro"
      />
      <van-field
      v-model="params.reg_time"
      clearable
      label="注册时间"
      disabled
      input-align="right"
      />
    </van-cell-group>
    <van-action-sheet :round='false' v-model="showPicker" :actions="columns" @select="onSelect" />
    <van-popup v-model="showArea" position="bottom">
      <van-area 
      v-show="showArea" 
      :area-list="areaList" 
      @cancel="showArea = false"
      @confirm="onConfirmArea" />
    </van-popup>
    <div class="text-c">
      <van-button round size="large" @click="updateInfo" :disabled="submitbtn" color="#F6AB00">保存</van-button>
      <van-button class="mt-20" round size="large" @click="exit" type="default">退出</van-button>
    </div>
  </div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import AreaList from '../../../libs/area';
  import { mapState } from 'vuex';
  import {Image, Icon, Field, Picker, Area ,Cell, CellGroup, Popup, Button, Uploader,ActionSheet,NavBar } from 'vant';
  export default {
    data(){
      return{
        params:{
          source:9,
          username:'',
          hometown:'',
          intro:'',
          sex:'',
          sexName:'男',
          avatar:'',
          avatar_url:'../../../assets/img/default.jpg'
        },
        showPicker:false,
        showArea:false,
        areaList:AreaList,
        columns:[{ name: '男' },
        { name: '女' },],
        submitbtn:true,
      }   
    },
    computed: {
      ...mapState({
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      if(!Lockr.get('token')) {

        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
            } else {
              this.$appService.needLogin()
            }
          })
        }

        if(this.source == 1){
         this.$store.commit('param/eqshow', true)
       }else{
        this.$toast('请先登录')
        return false
      }
    }
    if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})
    }
    
    this.getMemberInfo();
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    getMemberInfo(){
      member.getMemberInfo().then(res => {
        if(res.data.state == 1) {
          this.params=res.data.data
          if(this.params.province){
            this.params.hometown=this.params.province.name+this.params.city.name+this.params.district.name
            this.params.province_id=res.data.data.province.id
            this.params.city_id=res.data.data.city.id
            this.params.area_id=res.data.data.district.id
          }
          if(res.data.data.sex==1){
            this.params.sexName='男'
          }else{
           this.params.sexName='女' 
         }
         this.params.avatar_url=res.data.data.avatar
         this.params.avatar=''
       }
     })
    },
    showPickerd(e){
     this.showPicker = true;
   },
   onSelect(item) {
    this.params.sexName = item.name;
    if(item.name=='男'){
      this.params.sex =1
    }else{
      this.params.sex =2
    }
    this.showPicker = false;
    this.submitbtn=false
  },
  showAread(e){
    this.showArea=true;
  },
  onConfirmArea(value){
    this.params.hometown=value[0].name+value[1].name+value[2].name;
    this.params.province_id=value[0].code;
    this.params.city_id=value[1].code;
    this.params.area_id=value[2].code;
    this.showArea=false;
    this.submitbtn=false;
  },
  afterRead(file) {
    let params = new FormData()
    params.append('img', file.file)
    params.append('type',2)
    member.uploadImg(params).then(res => {
      if(res.data.state == 1) {
        this.params.avatar_url=res.data.data.img_url
        this.params.avatar=res.data.data.img
        this.submitbtn=false
      }
    })
  },
  checkName(value){
    this.submitbtn=false
    this.params.username=value
  },
  checkIntro(value){
    this.submitbtn=false
    this.params.intro=value
  },
  updateInfo(){
    member.updateInfo(this.params).then(res => {
      if(res.data.state == 1) {
       this.$toast.success('修改成功');
       this.getMemberInfo()
     }
   })
  },
  onClickLeft(){
    this.$router.go(-1)
  },
  exit(){
    this.$dialog.confirm({
      message: '确定要退出汽车时间吗？'
    }).then(() => {
      axios.defaults.headers.common['Authorization'] = null
      this.$store.commit('param/token', '')
      this.$store.dispatch('param/setToken','')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      Lockr.flush()

      if(this.source == 3||this.source == 7) {
        this.$appService.needLogout()
        return false
      }
      this.$router.replace({ name: 'My' })
    }).catch(() => {
    });
  },
},
components: {
  [Field .name]: Field ,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [Picker.name]:Picker,
  [Area.name]:Area,   
  [CellGroup.name]:CellGroup,
  [Cell.name]:Cell,
  [Popup.name]:Popup,
  [Button.name]:Button,
  [Uploader.name]:Uploader,
  [ActionSheet.name]:ActionSheet,
  [NavBar.name]:NavBar 
}
}
</script>
<style lang="scss">
.member{
  // .van-nav-bar__left {
  //   left: 10px;
  // }
  .van-cell{
    padding: 10px 15px;
    .van-icon__image{
      width: 40px;
      height: 40px;
      .van-image__img{
        border-radius: 30px;
      }
    }
    .van-cell__title, .van-cell__value{
      padding: 10px 0;
    }
  }
  .text-c{
    margin-top: 30px;
    .van-button--large{
      width: 90%;
      height: 42px;
      line-height: 2;
    }
    .mt-20{
      margin-top: 20px;
    }
  }
  .van-uploader{
    width: 100%;
    .van-uploader__input-wrapper{
      width: 100%;
    }
  }
}
</style>